/**
 * Module-level ref that the ky client uses to call back into Auth0's
 * `getAccessTokenSilently` without importing React hooks.
 *
 * Auth0CookieSync (which runs inside <Auth0Provider>) sets this ref on mount.
 * The ky `beforeRetry` hook reads it to mint a fresh token on 401 retry.
 *
 * Why a module-level ref instead of an import?
 * - getAccessTokenSilently is a React hook return value, only valid inside
 *   a component tree wrapped by <Auth0Provider>.
 * - ky is configured at module-init time, outside any React tree.
 * - This ref bridges the two without coupling client.ts to React.
 */
export type GetAccessTokenSilently = () => Promise<string>;

export const getAccessTokenSilentlyRef: { current: GetAccessTokenSilently | null } = {
  current: null,
};
